import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { setAdminToken } from "@/lib/adminState";
import Logo from "@/components/Logo";

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/login", { username, password });
      setAdminToken(r.data.token);
      toast.success("Welcome back, admin");
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-[70vh] items-center justify-center overflow-hidden px-4 py-16">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url('https://picsum.photos/seed/xerotic-admin/1600/900')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/90 to-black" />

      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative z-10 w-full max-w-md rounded-sm border border-[#1a1a1a] bg-[#0a0a0a] p-8 shadow-[0_30px_80px_-20px_rgba(230,0,57,0.25)]"
      >
        <div className="mb-6 flex items-center justify-between">
          <Logo size="sm" />
          <span className="inline-flex items-center gap-1.5 rounded-sm border border-[#1a1a1a] bg-[#0f0f0f] px-2 py-1 text-[10px] uppercase tracking-[0.28em] text-[#a3a3a3]">
            <Lock className="h-3 w-3" /> Admin
          </span>
        </div>
        <h1 className="font-display text-3xl tracking-tight text-[#f2f2f2]">
          Sign in
        </h1>
        <p className="mt-1 text-sm text-[#a3a3a3]">
          Restricted access · curators only
        </p>

        <div className="mt-6 space-y-3">
          <div>
            <label className="mb-1 block text-[11px] uppercase tracking-[0.24em] text-[#666]">
              Username
            </label>
            <input
              data-testid="admin-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full rounded-sm border border-[#1a1a1a] bg-[#0f0f0f] px-3 py-2 text-sm text-[#f2f2f2] focus:border-[#e60039] focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-[11px] uppercase tracking-[0.24em] text-[#666]">
              Password
            </label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-sm border border-[#1a1a1a] bg-[#0f0f0f] px-3 py-2 text-sm text-[#f2f2f2] focus:border-[#e60039] focus:outline-none"
            />
          </div>
        </div>

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy}
          className="mt-6 w-full rounded-sm bg-[#e60039] py-3 text-sm font-medium uppercase tracking-[0.2em] text-white transition-colors hover:bg-[#b3002c] disabled:opacity-50"
        >
          {busy ? "Signing in..." : "Enter"}
        </button>

        <p className="mt-6 text-center text-[11px] uppercase tracking-[0.24em] text-[#666]">
          admin / admin
        </p>
      </form>
    </div>
  );
};

export default AdminLogin;
